import {HOSTAPP} from './hostAppConfig';

const brandCodeLocaleMap = {
    HAUS: {
        locale: 'en_US',
        learnMoreLinks: {
            [HOSTAPP.TX]: 'https://www.vrbo.com/l/hello-vrbo',
            [HOSTAPP.OWNER_LOGIN]: 'https://www.vrbo.com/l/hello-vrbo-partner',
            [HOSTAPP.LYP]: 'https://www.vrbo.com/l/hello-vrbo-partner',
        }
    },
    VRUS: {
        locale: 'en_US',
        name: 'VacationRentals',
        learnMoreLinks: {
            [HOSTAPP.TX]: 'https://www.vrbo.com/l/hello-vrbo',
            [HOSTAPP.OWNER_LOGIN]: 'https://www.vrbo.com/l/hello-vrbo-partner',
            [HOSTAPP.LYP]: 'https://www.vrbo.com/l/hello-vrbo-partner',
        }
    },
    LXUS: {
        locale: 'en_US',
        name: 'LuxuryRentals',
        learnMoreLinks: {
            [HOSTAPP.TX]: 'https://www.vrbo.com/l/hello-vrbo',
            [HOSTAPP.OWNER_LOGIN]: 'https://www.vrbo.com/l/hello-vrbo-partner',
            [HOSTAPP.LYP]: 'https://www.vrbo.com/l/hello-vrbo-partner',
        }
    },
    HACA: {
        locale: 'en_CA'
    },
    HABR: {
        locale: 'pt_BR'
    },
    HAIT: {
        locale: 'it_IT'
    },
    HASG: {
        'locale': 'en_SG'
    },
    HAGR: {
        locale: 'el_GR'
    },
    HAMX: {
        locale: 'es_MX'
    },
    HAFI: {
        locale: 'fi_FI'
    },
    HAJP: {
        locale: 'ja_JP'
    },
    HACF: {
        locale: 'fr_CA'
    },
    HANO: {
        locale: 'no_NO'
    },
    HASE: {
        locale: 'sv_SE'
    },
    HADK: {
        locale: 'da_DK'
    },
    HAPL: {
        locale: 'pl_PL'
    },
    HAES: {
        locale: 'es_ES'
    },
    HAPT: {
        locale: 'pt_PT'
    },
    HAAT: {
        locale: 'de_AT'
    },
    HDES: {
        locale: 'es_ES',
        name: 'Homelidays'
    },
    HDIT: {
        locale: 'it_IT',
        name: 'Homelidays'
    },
    HDFR: {
        locale: 'fr_FR',
        name: 'Homelidays',
        learnMoreLinks: {
            [HOSTAPP.OWNER_LOGIN]: 'https://www.abritel.fr/espacedecouverte/a/homelidays-rebranding-faqs',
            [HOSTAPP.LYP]: 'https://www.abritel.fr/espacedecouverte/a/homelidays-rebranding-faqs',
        }
    },
    CSEN: {
        locale: 'en_CA',
        title: 'CanadaStays has moved to Vrbo!',
        info: 'One site. More great vacation rentals.'
    },
    CSFR: {
        locale: 'fr_CA',
        title: 'CanadaStays est passée à Vrbo',
        info: 'Un seul site. Bien plus de superbes locations de vacances.'
    },
    TRES: {
        locale: 'es_ES',
        name: 'TopRural'
    },
    TRPT: {
        locale: 'pt_PT',
        name: 'TopRural'
    },
    TRIT: {
        locale: 'it_IT',
        name: 'TopRural'
    },
    TRFR: {
        locale: 'fr_CA',
        name: 'TopRural'
    },
    TRCA: {
        locale: 'en_CA',
        name: 'TopRural'
    },
    HAUK: {
        locale: 'en_GB',
        learnMoreLinks: {
            [HOSTAPP.TX]: 'https://www.vrbo.com/en-gb/about',
            [HOSTAPP.OWNER_LOGIN]: 'https://www.vrbo.com/en-gb/l/hello-vrbo-partner',
            [HOSTAPP.LYP]: 'https://www.vrbo.com/en-gb/l/hello-vrbo-partner'
        }
    },
    HANL: {
        locale: 'nl_NL',
        learnMoreLinks: {
            [HOSTAPP.TX]: 'https://www.vrbo.com/nl-nl/over-ons',
            [HOSTAPP.OWNER_LOGIN]: 'https://www.vrbo.com/nl-nl/l/hello-vrbo-partner',
            [HOSTAPP.LYP]: 'https://www.vrbo.com/nl-nl/l/hello-vrbo-partner'
        }
    },
    HAAU: {
        locale: 'en_AU',
        learnMoreLinks: {
            [HOSTAPP.OWNER_LOGIN]: 'https://www.vrbo.com/en-au/discoveryhub/a/vrbo-rebrand-faqs',
            [HOSTAPP.LYP]: 'https://www.vrbo.com/en-au/discoveryhub/a/vrbo-rebrand-faqs'
        }
    },
    HACO: {
        locale: 'es_CO'
    },
    HAAR: {
        locale: 'es_AR'
    },
    HANZ: {
        locale: 'en_NZ',
        learnMoreLinks: {
            [HOSTAPP.OWNER_LOGIN]: 'https://www.vrbo.com/en-nz/discoveryhub/a/vrbo-rebrand-faqs',
            [HOSTAPP.LYP]: 'https://www.vrbo.com/en-nz/discoveryhub/a/vrbo-rebrand-faqs'
        }
    },
    HADE: {
        locale: 'de_DE'
    },
    HACN: {
        locale: 'zh_CN'
    },
    HAHK: {
        locale: 'zh_HK'
    },
    HAID: {
        locale: 'id_ID'
    },
    HAKR: {
        locale: 'ko_KR'
    },
    HALK: {
        locale: 'en_LK'
    },
    HAMY: {
        locale: 'en_MY'
    },
    HAPH: {
        locale: 'en_PH'
    },
    HATH: {
        locale: 'th_TH'
    },
    HATW: {
        locale: 'zh_TW'
    },
    HAVN: {
        locale: 'vi_VN'
    },
    HAEC: {
        locale: 'es_EC'
    },
    HAUY: {
        locale: 'es_EY'
    },
    HAPE: {
        locale: 'es_PE'
    },
    HACL: {
        locale: 'es_PL'
    },
    ASIA: {
        locale: 'en_SG'
    },
    HAAE: {
        locale: 'ar_AE'
    },
    HAUF: {
        locale: 'fr_FR'
    },
    HAIN: {
        locale: 'en_IN'
    },
    HARU: {
        locale: 'ru_RU'
    },
    HATR: {
        locale: 'tr_TR'
    },
    BBUS: {
        locale: 'en_US',
        name: 'BedandBreakfast.com',
        info: 'New name. Same great bed and breakfasts, and much more.'
    },
    BBES: {
        locale: 'es_ES',
        name: 'BedandBreakfast.com',
    },
    BBIT: {
        locale: 'it_IT',
        name: 'BedandBreakfast.com',
    },
};

export default brandCodeLocaleMap;
